var _rect, _mask, _path, _ellipse, _ellipse2, _ellipse3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessageActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 43.5787,
    height: 43.6,
    rx: 9,
    fill: "#D9D9D9",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_794_273",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4288 33.3519C32.0863 33.3519 39.9153 27.9766 39.9153 21.3458C39.9153 14.715 32.0863 9.33966 22.4288 9.33966C12.7713 9.33966 4.94238 14.715 4.94238 21.3458C4.94238 25.0873 7.43511 28.4291 11.3425 30.631L11.5561 36.2602L17.8508 32.9362C19.3099 33.2073 20.8448 33.3519 22.4288 33.3519Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3425 30.631L13.3411 30.5552L13.2987 29.4376L12.3244 28.8886L11.3425 30.631ZM11.5561 36.2602L9.55754 36.3361L9.6781 39.5137L12.49 38.0288L11.5561 36.2602ZM17.8508 32.9362L18.216 30.9698L17.532 30.8428L16.9168 31.1677L17.8508 32.9362ZM37.9153 21.3458C37.9153 23.8117 36.4612 26.2644 33.6616 28.1866C30.871 30.1026 26.9057 31.3519 22.4288 31.3519V35.3519C27.6094 35.3519 32.3874 33.9135 35.9257 31.4841C39.4549 29.061 41.9153 25.5106 41.9153 21.3458H37.9153ZM22.4288 11.3397C26.9057 11.3397 30.871 12.589 33.6616 14.5049C36.4612 16.4272 37.9153 18.8798 37.9153 21.3458H41.9153C41.9153 17.181 39.4549 13.6305 35.9257 11.2074C32.3874 8.77802 27.6094 7.33966 22.4288 7.33966V11.3397ZM6.94238 21.3458C6.94238 18.8798 8.39647 16.4272 11.1961 14.5049C13.9866 12.589 17.9519 11.3397 22.4288 11.3397V7.33966C17.2482 7.33966 12.4703 8.77802 8.932 11.2074C5.40277 13.6305 2.94238 17.181 2.94238 21.3458H6.94238ZM12.3244 28.8886C8.80162 26.9035 6.94238 24.1228 6.94238 21.3458H2.94238C2.94238 26.0518 6.0686 29.9548 10.3607 32.3734L12.3244 28.8886ZM13.5547 36.1844L13.3411 30.5552L9.34396 30.7068L9.55754 36.3361L13.5547 36.1844ZM16.9168 31.1677L10.6222 34.4917L12.49 38.0288L18.7847 34.7048L16.9168 31.1677ZM22.4288 31.3519C20.9662 31.3519 19.5536 31.2183 18.216 30.9698L17.4855 34.9026C19.0663 35.1962 20.7234 35.3519 22.4288 35.3519V31.3519Z",
    fill: "#303030",
    mask: "url(#path-2-inside-1_794_273)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.7288,
    cy: 21.4265,
    rx: 2.19657,
    ry: 2.19759,
    fill: "#303030"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5149,
    cy: 21.4265,
    rx: 2.19657,
    ry: 2.19759,
    fill: "#303030"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.3013,
    cy: 21.4265,
    rx: 2.19657,
    ry: 2.19759,
    fill: "#303030"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageActive);
export default __webpack_public_path__ + "static/media/message-active.19a3b5ec2b281cd89e4d2658203a22a0.svg";
export { ForwardRef as ReactComponent };